import { Box, Grid, Typography } from '@mui/material';
import { Flight } from '@mui/icons-material';
import { isISO8601Duration, toHourMinutes, toHrMinDuration, toWeekDayDateMonYear } from '~/modules/helpers';
import { Carrier, Leg } from '~/types';
import CarrierLogo from './CarrierLogo';

export interface FlightCardItemLegDetailsMobileProps {
  leg: Leg;
  carriers: Carrier[];
  carrierLogoSize?: number;
  showAirportFullName?: boolean;
}

function FlightCardItemLegDetailsMobile({
  leg,
  carriers,
  carrierLogoSize = 40,
  showAirportFullName = false,
}: FlightCardItemLegDetailsMobileProps) {
  return (
    <Grid container spacing={1} mb={2}>
      {/* Left vertical timeline */}
      <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            position: 'relative',
            pt: 1,
          }}
        >
          {/* Top Dot */}
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'black',
              zIndex: 1,
            }}
          />

          {/* Vertical Line */}
          <Box
            sx={{
              width: 2,
              flexGrow: 1,
              backgroundColor: 'black',
              my: 0.5,
            }}
          />

          {/* Plane Icon */}
          <Flight sx={{ fontSize: 20, transform: 'rotate(90deg)', my: 1 }} />

          {/* Vertical Line */}
          <Box
            sx={{
              width: 2,
              flexGrow: 1,
              backgroundColor: 'black',
              my: 0.5,
            }}
          />

          {/* Bottom Dot */}
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'black',
              zIndex: 1,
            }}
          />
        </Box>
      </Grid>

      {/* Flight details */}
      <Grid item xs={10}>
        {/* Departure Info */}
        <Box mb={2}>
          <Typography variant='body2'>{toWeekDayDateMonYear(leg.departure.dateTime)}</Typography>
          <Typography variant='h6'>
            {leg.departure.city.friendlyName} {!showAirportFullName && <small>({leg.departure.location.code})</small>}
          </Typography>
          <Typography variant='subtitle2'>
            {leg.departure.location.friendlyName} <small>({leg.departure.location.code})</small>
          </Typography>
          {leg.departure.terminal && (
            <Typography variant='subtitle2'>Terminal: {leg.departure.terminal}</Typography>
          )}
          <Typography variant='h5'>{toHourMinutes(leg.departure.dateTime)}</Typography>
        </Box>

        {/* Flight Info with Logo */}
        {/* Flight Info with Logo and Text */}
        <Box display='flex' alignItems='center' mb={2} ml={1}>
          {carriers.map((carrier, i) => (
            <CarrierLogo
              key={i}
              carrier={carrier}
              hideText
              boxStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 4,
                width: carrierLogoSize,
                height: carrierLogoSize,
                borderRadius: '50%',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                background: '#fff',
                marginRight: 1.5,
              }}
              imageStyle={{
                height: 'auto',
                width: '80%',
              }}
            />
          ))}
          <Box lineHeight={0.5} ml={1}>
            <Typography variant='subtitle2' fontWeight="bold">
              {isISO8601Duration(leg.duration) ? toHrMinDuration(leg.duration) : leg.duration}
            </Typography>
            <Typography variant='body2' style={{ textTransform: "capitalize" }}>
              {leg?.operatedBy?.friendlyName?.toLowerCase()} ({leg?.carrier.code}{leg?.flightNumber})<br /> {leg.aircraft?.friendlyName?.toLowerCase() || ''}
            </Typography>

          </Box>
        </Box>


        {/* Arrival Info */}
        <Box>
          <Typography variant='body2'>{toWeekDayDateMonYear(leg.arrival.dateTime)}</Typography>
          <Typography variant='h6'>
            {leg.arrival.city.friendlyName} {!showAirportFullName && <small>({leg.arrival.location.code})</small>}
          </Typography>
          <Typography variant='subtitle2'>
            {leg.arrival.location.friendlyName} <small>({leg.arrival.location.code})</small>
          </Typography>
          {leg.arrival.terminal && (
            <Typography variant='subtitle2'>Terminal: {leg.arrival.terminal}</Typography>
          )}
          <Typography variant='h5'>{toHourMinutes(leg.arrival.dateTime)}</Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FlightCardItemLegDetailsMobile;
